import React from "react";
import { Link } from "react-router-dom";
import "../css/home.css";
import homeicon from "../asset/dataex.png";



const Home = () => {
  return (
    <>
    <div className="container py-3">
            <div className="row gx-7">
                <div className="col-lg-5">
                    <div className='homeinfo'>
                    <div className="section-title position-relative mb-4 pb-2">
                        <h1 className="text-primary"><strong>MLGUI</strong></h1>
                        <h2 className="mt-2 text-light">The Best Machine Learning Tool for Building the Models.</h2>
                    </div>
                    <p className="mb-4 text-light h4"><strong className='h2 text-primary'>Congratulation!</strong>, Now You can build end-to-end Machine Learning Models with the help of the MLGUI without writing a single line of the code. This tool will help to build your machine learning models within few minutes. </p>
                    <div className="row ">
                        <div className="col-sm-6">
                            <h6 className="mb-3 text-light h5"><i className="fa fa-check text-primary me-2"></i>Faster</h6>
                            <h6 className="mb-0 text-light h5"><i className="fa fa-check text-primary me-2"></i>Documentation</h6>
                        </div>
                        <div className="col-sm-6">
                            <h6 className="mb-3 text-light h5"><i className="fa fa-check text-primary me-2"></i>Easy</h6>
                            <h6 className="mb-0 text-light h5"><i className="fa fa-check text-primary me-2"></i>Fair Prices</h6>
                        </div>
                    </div>
                    <div className="d-flex align-items-center mt-4">
                        <Link className="btn btn-primary rounded-pill px-4 me-3" to="/workarea"><h4 className="mx-3 my-2">Start<b>&rarr;</b></h4></Link>
                        
                    </div>
                    </div>
                </div>
                <div className="col-lg-6 ms-5">
                  <img className='homeimg' src={homeicon} alt="Home Icon"></img>
                  <a className="homeimg text-center" href="http://www.freepik.com">Designed by stories / Freepik</a>
                </div>
            </div>
      
    </div>
     
    {/* <div className="container my-5">
      <div className="poster text-center">
        <div className="startpage">
          <h3 className="mt-5">MLGUI</h3>
          <Link to="/workarea" className="btn btn-success rounded-pill my-1 ">
            Start<b>&rarr;</b>
          </Link>
        </div>
      </div>
      <div className="container my-5">
        <div className="text-center text-light">
          <h2 id="timeline">Start Your Journey</h2>
          <hr />
        </div>
        <ul className="timeline">
          <li>
            <div className="timeline-badge py-3">
              <h2>1</h2>
            </div>
            <div className="timeline-panel">
              <div className="timeline-heading">
                <h4 className="timeline-title">Data Description</h4>
                <p>
                  <small className="text-muted"> 5 min read</small>
                </p>
              </div>
              <div className="timeline-body">
                <p>
                  Mussum ipsum cacilds, vidis litro abertis. Consetis
                  adipiscings elitis. Pra lá , depois divoltis porris, paradis.
                  Paisis, filhis, espiritis santis. Mé faiz elementum girarzis,
                  nisi eros vermeio, in elementis mé pra quem é amistosis quis
                  leo. Manduma pindureta quium dia nois paga. Sapien in monti
                  palavris qui num significa nadis i pareci latim.
                  Interessantiss quisso pudia ce receita de bolis, mais bolis eu
                  num gostis.
                </p>
              </div>
            </div>
          </li>
          <li className="timeline-inverted">
            <div className="timeline-badge warning py-3">
              <h2>2</h2>
            </div>
            <div className="timeline-panel">
              <div className="timeline-heading">
                <h4 className="timeline-title">Data Pre-processing</h4>
              </div>
              <div className="timeline-body">
                <p>
                  Mussum ipsum cacilds, vidis litro abertis. Consetis
                  adipiscings elitis. Pra lá , depois divoltis porris, paradis.
                  Paisis, filhis, espiritis santis. Mé faiz elementum girarzis,
                  nisi eros vermeio, in elementis mé pra quem é amistosis quis
                  leo. Manduma pindureta quium dia nois paga. Sapien in monti
                  palavris qui num significa nadis i pareci latim.
                  Interessantiss quisso pudia ce receita de bolis, mais bolis eu
                  num gostis.
                </p>
              </div>
            </div>
          </li>
          <li>
            <div className="timeline-badge danger py-3">
              <h2>3</h2>
            </div>
            <div className="timeline-panel">
              <div className="timeline-heading">
                <h4 className="timeline-title">Data Visualization</h4>
              </div>
              <div className="timeline-body">
                <p>
                  Mussum ipsum cacilds, vidis litro abertis. Consetis
                  adipiscings elitis. Pra lá , depois divoltis porris, paradis.
                  Paisis, filhis, espiritis santis. Mé faiz elementum girarzis,
                  nisi eros vermeio, in elementis mé pra quem é amistosis quis
                  leo. Manduma pindureta quium dia nois paga. Sapien in monti
                  palavris qui num significa nadis i pareci latim.
                  Interessantiss quisso pudia ce receita de bolis, mais bolis eu
                  num gostis.
                </p>
              </div>
            </div>
          </li>
          <li className="timeline-inverted">
            <div className="timeline-badge info py-3">
              <h2>4</h2>
            </div>
            <div className="timeline-panel">
              <div className="timeline-heading">
                <h4 className="timeline-title">Feature Engineering</h4>
              </div>
              <div className="timeline-body">
                <p>
                  Mussum ipsum cacilds, vidis litro abertis. Consetis
                  adipiscings elitis. Pra lá , depois divoltis porris, paradis.
                  Paisis, filhis, espiritis santis. Mé faiz elementum girarzis,
                  nisi eros vermeio, in elementis mé pra quem é amistosis quis
                  leo. Manduma pindureta quium dia nois paga. Sapien in monti
                  palavris qui num significa nadis i pareci latim.
                  Interessantiss quisso pudia ce receita de bolis, mais bolis eu
                  num gostis.
                </p>
              </div>
            </div>
          </li>
          <li>
            <div className="timeline-badge success py-3">
              <h2>5</h2>
            </div>
            <div className="timeline-panel">
              <div className="timeline-heading">
                <h4 className="timeline-title">Model Building</h4>
              </div>
              <div className="timeline-body">
                <p>
                  Mussum ipsum cacilds, vidis litro abertis. Consetis
                  adipiscings elitis. Pra lá , depois divoltis porris, paradis.
                  Paisis, filhis, espiritis santis. Mé faiz elementum girarzis,
                  nisi eros vermeio, in elementis mé pra quem é amistosis quis
                  leo. Manduma pindureta quium dia nois paga. Sapien in monti
                  palavris qui num significa nadis i pareci latim.
                  Interessantiss quisso pudia ce receita de bolis, mais bolis eu
                  num gostis.
                </p>
              </div>
            </div>
          </li>
          <li className="timeline-inverted">
            <div className="timeline-badge primary py-3">
              <h3 className="text-center">6</h3>
            </div>
            <div className="timeline-panel">
              <div className="timeline-heading">
                <h4 className="timeline-title">Model Evalutions</h4>
              </div>
              <div className="timeline-body">
                <p>
                  Mussum ipsum cacilds, vidis litro abertis. Consetis
                  adipiscings elitis. Pra lá , depois divoltis porris, paradis.
                  Paisis, filhis, espiritis santis. Mé faiz elementum girarzis,
                  nisi eros vermeio, in elementis mé pra quem é amistosis quis
                  leo. Manduma pindureta quium dia nois paga. Sapien in monti
                  palavris qui num significa nadis i pareci latim.
                  Interessantiss quisso pudia ce receita de bolis, mais bolis eu
                  num gostis.
                </p>
              </div>
            </div>
          </li>
          <li>
            <div className="timeline-badge success py-3">
              <h3>7</h3>
            </div>
            <div className="timeline-panel">
              <div className="timeline-heading">
                <h4 className="timeline-title">Model Tunning</h4>
              </div>
              <div className="timeline-body">
                <p>
                  Mussum ipsum cacilds, vidis litro abertis. Consetis
                  adipiscings elitis. Pra lá , depois divoltis porris, paradis.
                  Paisis, filhis, espiritis santis. Mé faiz elementum girarzis,
                  nisi eros vermeio, in elementis mé pra quem é amistosis quis
                  leo. Manduma pindureta quium dia nois paga. Sapien in monti
                  palavris qui num significa nadis i pareci latim.
                  Interessantiss quisso pudia ce receita de bolis, mais bolis eu
                  num gostis.
                </p>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div> */}
    </>
  );
  
};

export default Home;
